import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-action-dull-input',
  templateUrl: './action-dull-input.component.html',
  styleUrls: ['./action-dull-input.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ActionDullInputComponent {

  @Input() label: string;

  constructor() {
  }
}
